<form #agentContactDetailForm="ngForm">
    <tg-row class="property-contact-details">
        <tg-col lg="6" md="8" sm="12">
            <tg-row>
                <tg-col *ngIf="contactDetailType === propertyAgentContactDetailsType.primary">
                    <h2>Contact details</h2>
                </tg-col>
                <tg-col *ngIf="contactDetailType === propertyAgentContactDetailsType.secondary">
                    <div class="second-contact-header">
                        <h2>Second contact details</h2>
                        <button type="button" class="remove-button" (click)="onDeleteContactDetails()">
                            <ng-container>
                                <tg-icon name="basic-cross" role="presentation" size="small"></tg-icon>
                                <span>Remove second contact</span>
                            </ng-container>
                        </button>
                    </div>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col>
                    <tg-row>
                        <tg-col>
                            <tg-input-container
                                label="Full name"
                                showRemainingCharacters="false">
                                <input
                                    tgTextInput
                                    name="name"
                                    type="text"
                                    (blur)="onContactDetailsChange()"
                                    [(ngModel)]="
                                        draftData.propertyInformation[contactFieldKeys.name]
                                    "
                                    [validation]="
                                        validation
                                            .propertyInformation
                                            .name | toValidator
                                    "
                                />
                            </tg-input-container>
                        </tg-col>
                    </tg-row>
                    <tg-row>
                        <tg-col *ngIf="hasErrorInContactDetails" sm="1" class="vertical-error-line">
                            <div></div>
                        </tg-col>
                        <tg-col
                            [sm]="hasErrorInContactDetails ? 11 : 12"
                            [ngClass]="{ 'property-contact-details__subtract-margin-left': hasErrorInContactDetails }">
                            <tg-row>
                                <tg-col sm="12">
                                <p class="property-contact-details__contact-detail-copy">
                                    Please enter at least one of the following contact details
                                </p>
                                </tg-col>
                            </tg-row>
                            <tg-row>
                                <tg-col sm="12" md="6">
                                    <tg-input-container
                                        label="Mobile phone"
                                        class="hide-optional-label">
                                        <input
                                            ngModel
                                            name="mobile"
                                            tgTextInput
                                            tgInputMask
                                            (blur)="onContactDetailsChange()"
                                            [(ngModel)]="
                                                draftData.propertyInformation[contactFieldKeys.mobile]
                                            "
                                            [type]="
                                                validation
                                                    .propertyInformation
                                                    [contactFieldKeys.mobile]?.type || 'text'
                                            "
                                            [validation]="phoneValidation.mobile | toValidator"
                                        />
                                        <tg-input-mask-pattern
                                            [regex]="otherCountryPhoneNumberRegex"
                                            pattern="** *** **** ****"
                                            allow="[0-9]"
                                        >
                                        </tg-input-mask-pattern>
                                        <tg-input-mask-pattern
                                            [regex]="freeCallPhoneNumberRegex"
                                            pattern="**** *** ****"
                                            allow="[0-9]"
                                        >
                                        </tg-input-mask-pattern>
                                        <tg-input-mask-pattern
                                            [regex]="homePhoneNumberRegex"
                                            pattern="** *** ****"
                                            allow="[0-9]"
                                        >
                                        </tg-input-mask-pattern>
                                        <tg-input-mask-pattern
                                            [regex]="mobilePhoneNumberRegex"
                                            pattern="*** *** *****"
                                            allow="[0-9]">
                                        </tg-input-mask-pattern>
                                    </tg-input-container>
                                </tg-col>
                                <tg-col sm="12" md="6">
                                    <tg-input-container
                                        label="Landline phone"
                                        class="hide-optional-label">
                                        <input
                                            ngModel
                                            name="landline"
                                            tgTextInput
                                            tgInputMask
                                            (blur)="onContactDetailsChange()"
                                            [(ngModel)]="
                                                draftData.propertyInformation[contactFieldKeys.landLine]
                                            "
                                            [type]="
                                                validation
                                                    .propertyInformation
                                                    [contactFieldKeys.landLine]?.type || 'text'
                                            "
                                            [validation]="phoneValidation.landLine | toValidator"
                                        />
                                        <tg-input-mask-pattern
                                            [regex]="otherCountryPhoneNumberRegex"
                                            pattern="** *** **** ****"
                                            allow="[0-9]">
                                        </tg-input-mask-pattern>
                                        <tg-input-mask-pattern
                                            [regex]="freeCallPhoneNumberRegex"
                                            pattern="**** *** ****"
                                            allow="[0-9]">
                                        </tg-input-mask-pattern>
                                        <tg-input-mask-pattern
                                            [regex]="homePhoneNumberRegex"
                                            pattern="** *** ****"
                                            allow="[0-9]">
                                        </tg-input-mask-pattern>
                                        <tg-input-mask-pattern
                                            [regex]="mobilePhoneNumberRegex"
                                            pattern="*** *** *****"
                                            allow="[0-9]">
                                        </tg-input-mask-pattern>
                                    </tg-input-container>
                                </tg-col>
                            </tg-row>
                            <tg-row>
                                <tg-col>
                                    <tg-input-container
                                        label="Email"
                                        class="hide-optional-label">
                                        <input
                                            tgTextInput
                                            name="email"
                                            type="email"
                                            (blur)="onContactDetailsChange()"
                                            [(ngModel)]="
                                                draftData.propertyInformation[contactFieldKeys.email]
                                            "
                                            email
                                        />
                                    </tg-input-container>
                                </tg-col>
                            </tg-row>
                            <tg-row *ngIf="hasErrorInContactDetails">
                                <tg-col>
                                    <p class="property-contact-details__validate-fail">
                                        At least one phone number or
                                        email address is required
                                    </p>
                                </tg-col>
                            </tg-row>
                        </tg-col>
                    </tg-row>
                    <property-agent-profile-photo
                        [photo]="agentPhoto"
                        [isPhotoRemovalDisabled]="isPhotoRemovalDisabled"
                        (photoSelected)="onPhotoSelected($event)"
                        (agentPhotoRemoved)="onAgentPhotoRemoved($event)"
                    ></property-agent-profile-photo>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
